<template>
  <v-container>
    <validation-observer v-slot="{ invalid }">
      <v-row justify="center">
        <v-col md="8">
          <v-card>
            <v-toolbar flat color="secondary" dark class="justify-center">
              <v-toolbar-title>اطلاعات کاربر جدید</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
               <span class="grey--text text--darken-1">
                 اطلاعات خواسته شده را تکمیل کنید.
               </span>
              <validation-provider
                  v-slot="{ errors }"
                  ref="phone"
                  name="code"
                  rules="required|phone">
                <v-text-field
                    type="digit"
                    label="شماره تلفن همراه"
                    v-model="user.phone"
                    :error-messages="errors"
                    required
                />
              </validation-provider>
              <validation-provider
                  v-slot="{ errors }"
                  rules="required">
                <v-text-field
                    label="نام"
                    v-model="user.first_name"
                    :error-messages="errors"
                />
              </validation-provider>
              <validation-provider
                  v-slot="{ errors }"
                  rules="required">
                <v-text-field
                    label="نام خانوادگی"
                    v-model="user.last_name"
                    :error-messages="errors"
                />
              </validation-provider>
              <validation-provider
                  v-slot="{ errors }"
                  rules="required|digits:10">
                <v-text-field
                    label="کدملی"
                    v-model="user.national_code"
                    :error-messages="errors"
                    required
                />
              </validation-provider>

              <validation-provider
                  v-slot="{ errors }"
                  name="pass"
                  vid="pass"
                  rules="required">
                <v-text-field
                    label="گذرواژه"
                    v-model="user.password"
                    type="password"
                    :error-messages="errors"
                    required
                />
              </validation-provider>
              <validation-provider
                  v-slot="{ errors }"
                  name="repass"
                  rules="required|is:@pass">
                <v-text-field
                    label="تکرار گذرواژه"
                    type="password"
                    v-model="user.confirm_password"
                    :error-messages="errors"
                    required
                />
              </validation-provider>

              <v-switch
                  label="دانش آموز"
                  v-model="is_student">
              </v-switch>


              <br>
              <!--              <span class="red&#45;&#45;text text&#45;&#45;darken-1" :v-bind="error_message">-->
              <!--                 {{ error_message }}-->
              <!--                </span>-->
            </v-card-text>
            <v-card-actions>
              <v-btn @click="add_user" color="primary" block :disabled="invalid">
                افزودن کاربر
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-col>
      </v-row>
    </validation-observer>


  </v-container>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";

extend('phone', value => {
  let phone = value.replace(/ /g, '')
  if (phone.length === 11 && phone.startsWith('0')) {
    return true
  }
  return 'شماره موبایل وارد شده صحیح نمیباشد'
})

export default {
  name: "AddUser",
  components: {
    ValidationObserver, ValidationProvider
  },
  data() {
    return {
      user: {
        phone: null,
        password: null,
        confirm_password: null,
        national_code: null,
        first_name: null,
        last_name: null,
        user_type: null,
      },
      is_student: false,

    }
  },
  methods: {
    add_user() {

      let context = this
      this.user.user_type = this.is_student ? 1 : 3,
          this.$store.dispatch('add_user', {user: this.user}).catch(function (error) {
            console.log(error)
            context.show_error(error.response.status)
          })
    },
    show_error(status) {
      if (status == 409) {
        this.$refs.phone.applyResult({
          errors: ["شماره موبایل تکراری است."],
          valid: true,
          failedRules: {}
        });
      }
    }
  }
}
</script>

<style scoped>

</style>